import { render } from "./BottomActions.vue?vue&type=template&id=450888f7"
import script from "./BottomActions.vue?vue&type=script&lang=js"
export * from "./BottomActions.vue?vue&type=script&lang=js"

import "./BottomActions.vue?vue&type=style&index=0&id=450888f7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__